import styles from "./ArticleSocials.module.scss";

const ArticleSocials = () => {
  return (
    <div className={styles.article__socials}>
      <span>Поделиться</span>
      <ul className={styles.article__list}>
        <li>
          <a
            href="https://loading..."
            target="_blank"
            rel="noopener noreferrer"
            className={styles.article__link}
          >
            <svg
              width="21"
              height="17"
              viewBox="0 0 21 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.8 2.00249C20.02 2.34049 19.214 2.57449 18.356 2.67849C19.24 2.15849 19.916 1.32649 20.228 0.312488C19.396 0.806488 18.486 1.14449 17.524 1.35249C16.744 0.520488 15.626 0.000488281 14.404 0.000488281C12.038 0.000488281 10.14 1.92449 10.14 4.26449C10.14 4.60249 10.166 4.91449 10.244 5.22649C6.708 5.07049 3.588 3.35449 1.482 0.780488C-0.0259998 3.48449 1.664 5.72049 2.782 6.47449C2.106 6.47449 1.43 6.26649 0.858 5.95449C0.858 8.06049 2.34 9.80249 4.264 10.1925C3.848 10.3225 2.912 10.4005 2.34 10.2705C2.886 11.9605 4.472 13.2085 6.318 13.2345C4.862 14.3785 2.73 15.2885 0 15.0025C1.898 16.2245 4.134 16.9265 6.552 16.9265C14.404 16.9265 18.668 10.4265 18.668 4.81049C18.668 4.62849 18.668 4.44649 18.642 4.26449C19.526 3.61449 20.254 2.86049 20.8 2.00249Z"
                fill="#4B7159"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://loading..."
            target="_blank"
            rel="noopener noreferrer"
            className={styles.article__link}
          >
            <svg
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.4398 9.922C3.3738 9.922 1.9218 9.922 1.2618 9.922C0.909805 9.922 0.799805 9.79 0.799805 9.46C0.799805 8.58 0.799805 7.678 0.799805 6.798C0.799805 6.446 0.931805 6.336 1.2618 6.336H3.4398C3.4398 6.27 3.4398 4.994 3.4398 4.4C3.4398 3.52 3.5938 2.684 4.0338 1.914C4.4958 1.122 5.1558 0.594 5.9918 0.286C6.5418 0.0879998 7.0918 0 7.6858 0H9.84179C10.1498 0 10.2818 0.132 10.2818 0.44V2.948C10.2818 3.256 10.1498 3.388 9.84179 3.388C9.24779 3.388 8.6538 3.388 8.0598 3.41C7.4658 3.41 7.1578 3.696 7.1578 4.312C7.1358 4.972 7.1578 5.61 7.1578 6.292H9.70979C10.0618 6.292 10.1938 6.424 10.1938 6.776V9.438C10.1938 9.79 10.0838 9.9 9.70979 9.9C8.9178 9.9 7.2238 9.9 7.1578 9.9V17.072C7.1578 17.446 7.0478 17.578 6.6518 17.578C5.7278 17.578 4.8258 17.578 3.9018 17.578C3.5718 17.578 3.4398 17.446 3.4398 17.116C3.4398 14.806 3.4398 9.988 3.4398 9.922Z"
                fill="#4B7159"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://loading..."
            target="_blank"
            rel="noopener noreferrer"
            className={styles.article__link}
          >
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.281977 8.50098C-0.118023 3.30098 1.44864 1.00098 2.28198 0.500977L6.78198 0.000976562L13.782 0.500977L15.282 1.50098L16.282 3.50098V8.00098V11.501L15.782 14.501L14.782 15.501L12.282 16.501H9.78198L4.78198 16.001C3.94865 16.001 2.18198 15.901 1.78198 15.501C1.74627 15.4653 1.71055 15.4321 1.67484 15.3989C1.21056 14.9678 0.746262 14.5367 0.281977 8.50098ZM8.28199 3.50098C5.79624 3.50098 3.7821 5.51534 3.7821 8.00087C3.7821 10.4855 5.79624 12.5012 8.28199 12.5012C10.767 12.5012 12.7819 10.4855 12.7819 8.00087C12.7819 5.51534 10.767 3.50098 8.28199 3.50098ZM8.28199 11.0012C6.62534 11.0012 5.28214 9.65796 5.28214 8.00087C5.28214 6.34377 6.62534 5.00101 8.28199 5.00101C9.93865 5.00101 11.2818 6.34377 11.2818 8.00087C11.2818 9.65796 9.93865 11.0012 8.28199 11.0012ZM14.2825 3.12546C14.2825 3.74677 13.7789 4.25043 13.1576 4.25043C12.5363 4.25043 12.0326 3.74677 12.0326 3.12546C12.0326 2.50416 12.5363 2.00049 13.1576 2.00049C13.7789 2.00049 14.2825 2.50416 14.2825 3.12546Z"
                fill="#4B7159"
              />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ArticleSocials;
